// extracted by mini-css-extract-plugin
export default {"form":"Form_form__3k4Mb","input":"Form_input__3q8LU","btn":"Form_btn__HW2Hs","success":"Form_success__y8jpv","big":"Form_big__lywLS"};